import React from "react";

export default props => <p>Página no encontrada</p>;
